import React, { useState, useEffect } from 'react';
import TripServices from '../services/externalServices/tripServices';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Grid, Paper, CardHeader, CardContent, Select, MenuItem, FormControl, InputLabel, Divider } from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from "react-redux";


function TripTrafficChart() {
  const dispatch = useDispatch();
    const {serviceType} = useSelector((state) => state.serviceType.serviceType);
  const [tripData, setTripData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format('MMMM'));

  useEffect(() => {
    getTripDetails();
  }, [serviceType]);

  const getTripDetails = async () => {
    try {
      const response = await TripServices.getTripDetails(serviceType);
      const tripsdata = response;
      const sortedTripData = tripsdata
        .slice()
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      setTripData(sortedTripData);
    } catch (error) {
      console.error("Error fetching trip data:", error);
    }
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const filteredTripData = tripData.filter(trip => {
    const tripMonth = dayjs(trip.created_at).format('MMMM');
    return tripMonth === selectedMonth;
  });

  const tripHours = filteredTripData.map(trip => new Date(trip.created_at).getHours());
  const tripCountsPerHour = Array.from({ length: 24 }, (_, i) =>
    tripHours.filter(hour => hour === i).length
  );

  const allHours12 = Array.from({ length: 24 }, (_, i) => {
    const period = i < 12 ? "AM" : "PM";
    const formattedHour = i % 12 === 0 ? 12 : i % 12;
    return `${formattedHour}:${i === 0 ? "00" : "00"} ${period}`;
  });

  const data = allHours12.map((hour, index) => ({
    hour,
    tripCounts: tripCountsPerHour[index]
  }));

  const months = Array.from({ length: 12 }, (_, i) => dayjs().month(i).format('MMMM'));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper elevation={1}>
          <CardHeader
            title="Trip Traffic Chart-Completed, Cancelled"
            titleTypographyProps={{ variant: 'h6', sx: { color: '#667085' } }}
            action={
              <FormControl size="small" >
                <InputLabel id="month-select-label">Month</InputLabel>
                <Select
                  labelId="month-select-label"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                >
                  {months.map((month) => (
                    <MenuItem key={month} value={month}>{month}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <div style={{ width: '100%', height: 300 }}>
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={data}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="hour" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Line type="monotone" dataKey="tripCounts" stroke="#8884d8" activeDot={{ r: 8 }} />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
          </CardContent>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default TripTrafficChart;
